import React, { createContext, useState, useContext, useMemo } from "react";
import { useVsiAppContext } from "../VsiApp";
import { Card, Spinner } from "reactstrap";
import { VsiH4 } from "../../styled/App.styled";
import { staticDateReliantReportContexts } from "../../utils/routes";

// that isn't confusing :)
const ReportContext = createContext();

export const ReportProvider = ({ children, context, title }) => {
  const [staticReportContext] = useState(context);
  const { isGettingPeriods, theme, doPeriodsMatchReportContext } = useVsiAppContext();

  const isLoading = useMemo(() => {
    return staticDateReliantReportContexts.includes(staticReportContext) && (isGettingPeriods || !doPeriodsMatchReportContext);
  }, [isGettingPeriods, doPeriodsMatchReportContext, staticReportContext]);

  return <ReportContext.Provider value={{ staticReportContext }}>
    {isLoading ? (
      <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>{title} <Spinner size={"sm"} color={"secondary"}/></VsiH4>
      </Card>
    ) : children}
  </ReportContext.Provider>
}

export const useReportContext = () => useContext(ReportContext);